'use strict';

/** @type {object} スクロールに関するデフォルト値 */
const DEFAULT = {
    /** @type {object} スクロールに関する定義 */
    SCROLL: {
        /** @type {number} スクロールにかかる時間(ms) */
        DURATION: 200,
    },
};

/**
 * 「#gnavi」「#header」が画面内に存在する場合、その高さをオフセット位置として返す。
 *
 * @returns {number} スクロール時における画面上部からのオフセット位置 例: `100`
 */
function getScrollOffset() {
    const offset = ($('#gnavi').outerHeight() || 0) + ($('#header').outerHeight() || 0);
    return offset;
}

/**
 * 引数で指定したオフセット位置にスクロールする。
 * 「#gnavi」「#header」が画面内に存在する場合は、その高さを考慮した上でオフセット位置を算出し直す。
 *
 * @param {number} offset - スクロール後に到達する位置 例: `200`
 * @param {(number|undefined)} duration - スクロール時のduration(ms)。指定しない場合はデフォルト値「DEFAULT.SCROLL.DURATION」(200)を適用する。 例: `200`
 */
function scroll(offset, duration) {
    const totalOffset = offset - getScrollOffset();
    $('html, body').animate({scrollTop: totalOffset}, duration || DEFAULT.SCROLL.DURATION);
}

/**
 * 引数で指定したアンカーにスクロールする。
 * 対象のアンカーが見つからない場合は何もしない。
 *
 * @param {string} id - アンカーのID 例: `'navigation'`
 * @param {(number|undefined)} duration - スクロール時のduration(ms)。指定しない場合はデフォルト値「DEFAULT.SCROLL.DURATION」(200)を適用する。 例: `200`
 */
function scrollToAnchor(id, duration) {
    if (!id) {
        return;
    }
    const $anchor = $(`#${id}`);
    if ($anchor.length !== 1) {
        return;
    }
    const offset = $anchor.offset().top;
    scroll(offset, duration);
}

module.exports = {
    scroll,
    scrollToAnchor,
};
